import Vue from 'vue'
import NuxtJsonld from 'nuxt-jsonld'

import Anchor from '~/components/common/Anchor.vue'

// Docs https://www.npmjs.com/package/nuxt-jsonld
Vue.use(NuxtJsonld)

Vue.component('Anchor', Anchor)
